import React, { useState } from 'react';
import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiFiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { withStyles } from '@material-ui/core';
//
import ExpansionPanel from 'components/expansion-panel';
import ExpansionPanelSummary from 'components/expansion-panel-summary';
import ExpansionPanelDetails from 'components/expansion-panel-details';
import DealDetails from 'components/sidebar/deal-management/deal-details';
import colors from 'theme/colors';
import { productTestId, creditTestId, nonRiskModaltestid } from 'components/sidebar/base-navigation/test-ids';
import Products from 'components/sidebar/deal-management/products';
import Credit from 'components/sidebar/deal-management/credit';
import AdditionalMandateView from 'components/sidebar/additional-mandate';

const { lightBackgroundBase, yellow } = colors;

const ExpandMoreIconStyled = withStyles({
  root: {
    fill: lightBackgroundBase,
  },
})(ExpandMoreIcon);

const DotIconContainer = styled.span`
  position: absolute;
  top: 12px;
`;

const DotIcon = styled(MuiFiberManualRecordIcon)`
  color: ${yellow};
  margin-left: 16px;
  width: 0.6em !important;
`;

interface IProps {
  doesContainCost: boolean;
}

export default ({ doesContainCost }: IProps) => {
  const dealIfoPanel = 'deal-information-panel';
  const [expanded, setExpanded] = useState<string | boolean>(dealIfoPanel);

  const handlePanelChange = (panel: string) => (_e: React.ChangeEvent<{}>, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <ExpansionPanel square expanded={expanded === dealIfoPanel} onChange={handlePanelChange(dealIfoPanel)}>
        <ExpansionPanelSummary
          aria-controls="deal-information-panel-content"
          id="deal-information-panel-header"
          expandIcon={<ExpandMoreIconStyled />}
        >
          <p>Deal Information</p>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <DealDetails />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel square expanded={expanded === 'product-panel'} onChange={handlePanelChange('product-panel')}>
        <ExpansionPanelSummary
          aria-controls="product-panel-content"
          id="product-panel-header"
          expandIcon={<ExpandMoreIconStyled />}
          data-testid={productTestId}
        >
          <p>Products</p>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Products />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel square expanded={expanded === 'credit-panel'} onChange={handlePanelChange('credit-panel')}>
        <ExpansionPanelSummary
          aria-controls="credit-panel-content"
          id="credit-panel-header"
          expandIcon={<ExpandMoreIconStyled />}
          data-testid={creditTestId}
        >
          <p>
            Credit<DotIconContainer>{doesContainCost && <DotIcon />}</DotIconContainer>
          </p>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Credit />
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel square expanded={expanded === 'nonrisk-panel'} onChange={handlePanelChange('nonrisk-panel')}>
        <ExpansionPanelSummary
          aria-controls="nonrisk-panel-content"
          id="nonrisk-panel-header"
          expandIcon={<ExpandMoreIconStyled />}
          data-testid={nonRiskModaltestid}
        >
          <p>Additional Mandate Details</p>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <AdditionalMandateView />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};
